import React, { useState } from 'react';
import Autocomplete from './Autocomplete';

const MinLengthAutocomplete = ({
  placeholder,
  options,
  setter,
  getOptionLabel,
  getOptionValue,
  value,
  validations,
  invalid,
  errorMessage,
  autocompleteRef,
  minLength = 2,
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const handleInputChange = (input, action) => {
    if (action === 'input-change') {
      if (input.length > minLength) {
        setOpen(true);
      } else {
        setOpen(false);
      }
      return;
    }
    if (action === 'set-value' || action === 'input-blur') {
      setOpen(false);
    }
  };
  return (
    <Autocomplete
      invalid={invalid}
      placeholder={placeholder}
      options={options}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      openMenuOnFocus={false}
      onInputChange={handleInputChange}
      menuIsOpen={open}
      errorMessage={errorMessage}
      validations={validations}
      value={value}
      setter={setter}
      noAutoSelect
      ref={autocompleteRef}
      {...rest}
    />
  );
};

export default MinLengthAutocomplete;
